<template>
  <main class="ws-page">
    <ws-exam-logs-list :guid="guid" />
  </main>
</template>

<script>
import WsExamLogsList from '@/components/de/demo-exams/WsExamLogsList'
export default {
  name: 'ExamsLogs',
  components: { WsExamLogsList },
  computed: {
    guid () {
      return this.$route.params.id
    }
  }
}
</script>
